/**
 * Dependencies.
 */
import { BaseModel } from '@prz-dp/services';

/**
 * Export `MqttPayloadModel`.
 */
export class MqttPayloadModel extends BaseModel {
  /**
   * Properties.
   */
  message: any;

  messageDate: string;

  type: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<MqttPayloadModel>) {
    super(data);
  }
}
